import useSWR from 'swr'

import {
  recipeFetcher as menuExperienceRecipeFetcher,
  type RecipeQueryResponse,
} from '@library/api-menu-experience'
import type { RecipeUUID } from '@library/menu-service'

type UseRecipeDetailDataInput = {
  menuId: string
  recipeUuid: RecipeUUID | null
  numPortions: number
  deliveryDate: string
  shouldFetchOptions?: boolean
  collectionId?: string
}

type UseRecipeDetailDataResult = {
  error: boolean
  loading: boolean
  recipe: RecipeQueryResponse | null
  reload: () => void
}

export const useRecipeDetailData = ({
  menuId,
  recipeUuid,
  numPortions,
  deliveryDate,
  shouldFetchOptions = true,
  collectionId,
}: UseRecipeDetailDataInput): UseRecipeDetailDataResult => {
  const { data, mutate, isValidating, error } = useSWR(
    () =>
      recipeUuid && shouldFetchOptions
        ? {
            menuId,
            recipeId: recipeUuid,
            numPortions,
            deliveryDate,
            collectionId,
          }
        : null,
    menuExperienceRecipeFetcher,
  )

  const reload = () => {
    mutate()
  }

  return {
    error: !!error,
    loading: !data && isValidating,
    recipe: data || null,
    reload,
  }
}
